import { Component } from 'react'
import { Upload, Progress } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import { withUploadModule, withS3ServiceRequestConvertor, Toast, Icon } from '@vzmi/shp_shared_compo'
import {
  fetchS3Object,
  fetchS3Wssid,
  fetchTempCredential
} from '../../../../../actions/serviceActions/common'
import {
  setDimension,
  setUidAndMimeType,
  verifyMismatchedFileMimeType
} from '../../../../../lib/uploaderUtil'
import _ from 'lodash'
import { getImgFileVerifierBy } from '../ImageUploaderHelper'
import { TOAST_DURATION } from '../../../../../constants/proposalTypes'
import styles from './AvatarUploader.css'

class Avatar extends Component {
  state = {
    percent: 0,
    loading: false
  }

  handleChange = info => {
    const percent = _.get(info, 'event.percent', 0)

    // onchange 在上傳完成後會多回傳一次 uploading && percent === 100
    if (info.file.status === 'uploading' && percent !== 100) {
      this.setState({
        loading: true,
        percent
      })
    }

    if (info.file.status === 'done') {
      // Get this url from response in real world.
      this.setState({
        loading: false,
        percent: 0
      })
    }

    this.props.handleChange(info)
  }

  render () {
    const {
      rule,
      imageUrl,
      readOnly,
      customRequest
    } = this.props

    const {
      percent,
      loading
    } = this.state

    return (
      <Upload
        name='avatar'
        listType='picture-card'
        showUploadList={false}
        disabled={readOnly}
        className={styles.avatarUploader}
        onChange={this.handleChange}
        customRequest={customRequest}
        beforeUpload={async (file, fileList) => {
          const preprocessedUploadFiles = await setUidAndMimeType(fileList).then(setDimension)

          const errors = _.reduce(preprocessedUploadFiles,
            (acc, file) => {
              const mimeTypeError = verifyMismatchedFileMimeType(file)
              if (mimeTypeError) {
                acc.push(mimeTypeError)
                return acc
              }

              const verify = getImgFileVerifierBy(rule)
              const { error: errorMessage } = verify(file)
              if (errorMessage) {
                acc.push(errorMessage)
              }
              return acc
            }, [])

          _.each(_.uniq(errors), e => {
            Toast.error(e, { duration: TOAST_DURATION })
          })

          return new Promise(
            (resolve, reject) => {
              return _.isEmpty(errors) ? resolve(file) : reject(file)
            }
          )
        }}
      >
        <>
          {
            imageUrl
              ? (
                <img
                  src={imageUrl}
                  alt='avatar'
                  style={{ width: '100%' }}
                />
              )
              : (
                <div>
                  {
                    loading
                      ? <LoadingOutlined />
                      : (
                        <Icon
                          name='fuji2/plus'
                          color='#000000a6'
                          size={14}
                        />
                      )
                  }
                </div>
              )
          }
          {
            loading
              ? (
                <Progress
                  type='line'
                  percent={percent}
                />
              )
              : null
          }
        </>
      </Upload>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    s3Service: bindActionCreators(
      {
        fetchS3Object,
        fetchS3Wssid,
        fetchTempCredential
      },
      dispatch
    )
  }
}

const enhance = compose(
  connect(
    null,
    mapDispatchToProps
  ),
  withS3ServiceRequestConvertor,
  withUploadModule
)

const AvatarUploader = enhance(Avatar)

export default AvatarUploader
